/*! @azure/msal-common v15.11.0 2025-08-12 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.11.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
